__turbopack_context__.v({
  "selectStoreMessage": "SelectStoreMessage-module-scss-module__aUWmSa__selectStoreMessage",
  "storeNameButton": "SelectStoreMessage-module-scss-module__aUWmSa__storeNameButton",
});
